import { PermissionDifferenceCalculator } from "./PermissionDifferenceCalculator";

export class PermissionDifferenceCalculatorFactory {
    private static INSTANCE = new PermissionDifferenceCalculator();

    public static getInstance() {
        return this.INSTANCE;
    }
}